import React, { useState } from "react";
import { motion } from "framer-motion";
import { InputField } from "@cakrawalajakarta/shared-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faLocationDot, faSearch } from "@fortawesome/free-solid-svg-icons";

export const Schedule = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const rundown = [
    {
      date: "23-24/09/2025",
      time: "12:00 - 20:00",
      activity: "Race Pack Collection (RPC 1)",
      location: "Decathlon Agora Mall",
    },
    {
      date: "26/09/2025",
      time: "09:00",
      activity: "Upacara Pembukaan Kejurda I ALTI DKI Jakarta",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "26/09/2025",
      time: "14:00 - 20:00",
      activity: "Race Pack Collection (RPC 2)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "26/09/2025",
      time: "14:00 - 15:00",
      activity: "Briefing Teknis / Route dan Mandatory",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "26/09/2025",
      time: "15:00 - 15:30",
      activity: "Foto Bersama",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "27/09/2025",
      time: "00:00",
      activity: "Open Gate Long Distance (80KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "27/09/2025",
      time: "01:00",
      activity: "Flag Off - Long Distance (80KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "27/09/2025",
      time: "04:30",
      activity: "Open Gate Short Distance (40KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "27/09/2025",
      time: "05:30",
      activity: "Flag Off - Short Distance (40KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "27/09/2025",
      time: "08:30",
      activity: "COP 1 Long Distance (80KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "27/09/2025",
      time: "13:00",
      activity: "COP 1 Short Distance (40KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "27/09/2025",
      time: "16:00",
      activity: "COP 2 Long Distance (80KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "27/09/2025",
      time: "20:30",
      activity: "COP 2 Short Distance (40KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "28/09/2025",
      time: "01:30",
      activity: "Cut Off Time Short Distance (40KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "02:00",
      activity: "COP 3 Long Distance (80KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "28/09/2025",
      time: "02:00",
      activity: "Open Gate Classic / Group Mix (20KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "03:00",
      activity: "Flag Off - Classic / Group Mix (20KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "05:30",
      activity: "Open Gate Vertical / Fun Trail (7KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "06:30",
      activity: "Flag Off - Vertical (7KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "07:00",
      activity: "Flag Off - Fun Trail (7KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "08:00",
      activity: "COP 4 Long Distance (80KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "28/09/2025",
      time: "10:30",
      activity: "COP 1 (Classic / Group Mix 20KM)",
      location: "Alun-Alun Tengah Surya Kencana",
    },
    {
      date: "28/09/2025",
      time: "11:00",
      activity: "Cut Off Time Fun Trail (7KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "12:00",
      activity: "Cut Off Time Long Distance (80KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "13:00 - 14:00",
      activity: "Upacara Penutupan Kejurda I DKI Jakarta",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "14:00 - 14:30",
      activity: "Penyerahan Podium Vertical & Classic / Fun Trail",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "14:30 - 14:45",
      activity: "Penyerahan Podium Short Distance",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "14:45 - 15:00",
      activity: "Penyerahan Podium Long Distance",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "15:00",
      activity: "Cut Off Time Classic / Group Mix (20KM)",
      location: "Venue Balai Besar TNGGP",
    },
    {
      date: "28/09/2025",
      time: "15:00 - 16:00",
      activity: "Dokumentasi Bersama",
      location: "Venue Balai Besar TNGGP",
    },
  ];

  // Function to parse time for sorting
  const parseTime = (time) => {
    const startTime = time.split(" - ")[0];
    const [hours, minutes] = startTime.split(":").map(Number);
    return hours * 60 + minutes;
  };

  // Filter berdasarkan search
  const filteredRundown = rundown.filter((entry) =>
    Object.values(entry).some((value) =>
      value.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  // Group by date and sort by time
  const groupedRundown = filteredRundown.reduce((acc, entry) => {
    acc[entry.date] = acc[entry.date] || [];
    acc[entry.date].push(entry);
    return acc;
  }, {});

  Object.keys(groupedRundown).forEach((date) => {
    groupedRundown[date].sort((a, b) => parseTime(a.time) - parseTime(b.time));
  });

  // Format tanggal untuk tampilan
  const formatDate = (dateString) => {
    if (!dateString) return "Tidak tersedia";
    try {
      if (dateString.includes("-")) {
        // Handle rentang tanggal seperti 23-24/09/2025
        const [range, month, year] = dateString.split("/");
        return `${range} Sep ${year}`;
      }
      const [day, month, year] = dateString.split("/");
      const date = new Date(`${year}-${month}-${day}`);
      if (isNaN(date)) return "Tidak tersedia";
      return date.toLocaleDateString("id-ID", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return "Tidak tersedia";
    }
  };

  return (
    <section
      id="schedule"
      className="w-full min-h-screen py-20 text-center text-lime-600 flex-col justify-center relative bg-white"
    >
      <div className="relative z-0 container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-6xl mx-auto space-y-4">
            {/* RPC Info */}
            <motion.div
              className="grid grid-cols-1 md:grid-cols-2 gap-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="bg-white rounded-xl px-6 py-8 md:py-12 border border-gray-200 flex flex-col items-center justify-center">
                <FontAwesomeIcon
                  icon={faBoxOpen}
                  className="text-4xl text-lime-600 mb-4"
                />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Decathlon+Agora+Mall"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-lime-600 font-bold mb-3 hover:underline flex items-center gap-2"
                >
                  <FontAwesomeIcon icon={faLocationDot} />
                  Lokasi RPC 1
                </a>
                <p className="text-xl text-lime-800">Decathlon Agora Mall</p>
                <p className="text-sm text-gray-600">
                  Tanggal: {formatDate("23-24/09/2025")} (12:00 - 20:00)
                </p>
              </div>

              <div className="bg-white rounded-xl px-6 py-8 md:py-12 border border-gray-200 flex flex-col items-center justify-center">
                <FontAwesomeIcon
                  icon={faBoxOpen}
                  className="text-4xl text-lime-600 mb-4"
                />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=Balai+Besar+TNGGP"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-lime-600 font-bold mb-3 hover:underline flex items-center gap-2"
                >
                  <FontAwesomeIcon icon={faLocationDot} />
                  Lokasi RPC 2
                </a>
                <p className="text-xl text-lime-800">Balai Besar TNGGP</p>
                <p className="text-sm text-gray-600">
                  Tanggal: {formatDate("26/09/2025")} (14:00 - 20:00)
                </p>
              </div>
            </motion.div>

            {/* Table Rundown */}
            <motion.div
              className="bg-white rounded-2xl border border-gray-200 text-left relative overflow-hidden max-w-6xl mx-auto"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
              viewport={{ once: true }}
            >
              <div className="flex justify-end mb-4 px-4 pt-4">
                <div className="w-full max-w-xs">
                  <InputField
                    name="search"
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Cari rundown..."
                    labelColor="text-lime-800"
                    startIcon={
                      <FontAwesomeIcon icon={faSearch} className="text-gray-400" />
                    }
                  />
                </div>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full table-auto divide-y divide-gray-200">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Tanggal
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Waktu
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Aktivitas
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                        Lokasi
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(groupedRundown).length > 0 ? (
                      Object.entries(groupedRundown).map(([date, entries]) =>
                        entries.map((entry, idx) => {
                          const isCutOff =
                            entry.activity.includes("Cut Off Time");
                          const isFlagOff = entry.activity.includes("Flag Off");
                          const isDate28 = date === "28/09/2025";
                          const rowColor = isFlagOff
                            ? "text-lime-600"
                            : isCutOff
                            ? "text-red-600"
                            : "text-gray-600";
                          return (
                            <tr
                              key={`${date}-${idx}`}
                              className={`border-b border-gray-200 last:border-b-0 hover:bg-gray-50 ${rowColor}`}
                            >
                              <td
                                className={`px-4 py-4 text-sm text-left ${
                                  isCutOff && isDate28
                                    ? "text-gray-600"
                                    : rowColor
                                }`}
                              >
                                {idx === 0 ? formatDate(date) : ""}
                              </td>
                              <td className="px-4 py-4 text-sm text-left">
                                {entry.time}
                              </td>
                              <td className="px-4 py-4 text-sm text-left">
                                {entry.activity}
                              </td>
                              <td className="px-4 py-4 text-sm text-left">
                                {entry.location}
                              </td>
                            </tr>
                          );
                        })
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="4"
                          className="px-4 py-4 text-sm text-gray-600 text-center"
                        >
                          Tidak ada data rundown tersedia.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};
